export const API_URL = 
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '192.168.1.221'
    ? `http://${window.location.hostname}:5001`
    : window.location.hostname.includes('pages.dev') || window.location.hostname === 'babysittingfind.ca' || window.location.hostname === 'www.babysittingfind.ca'
      ? ''
      : 'https://leadership-territories-organic-stopped.trycloudflare.com';
export const VAPID_PUBLIC_KEY = 'BJIBHbsZ4EnIQnr7fdOcjmqaA8VuNzAuwFTIzi8MKxhE21KzIVQfEsBVl9bhYnvrBnsI-YvpApgmjsl0icfZtr8';
